export const GET_PROMPT_FANOUT = 'get-prompt-fanout';
export const GET_ANSWER_FEATURES = 'get-answer-features';
export const GET_FEATURES_SUMMARY = 'get-features-summary';
